// basic package
import { library, config } from '@fortawesome/fontawesome-svg-core';

// free solid icons
import { 
  faComment,
  faEnvelope, 
  faEnvelopeOpen,
  faBars, 
  faBell, 
  faUser,
  faQuestionCircle, 
  faCheckCircle, 
  faExclamationCircle, 
  faInfoCircle,
  faHome,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faAddressCard,
  faDonate,
  faComments,
  faFilePdf,
  faShoppingCart,
  faTimes,
  faSignOutAlt,
  faBuilding,
  faBan,
  faCheck,
  faBolt,
  faFire,
  faFileAlt,
  faSearch,
  faThermometerThreeQuarters,
  faCreditCard,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faLongArrowAltUp,
  faLongArrowAltDown,
  faArrowsAltH,
  faPhone,
  faMobileAlt,
  faFax,
  faGlobe,
  faCalendarAlt,
  faCalendar,
  faCalendarCheck,
  faCalendarTimes,
  faPlug,
  faPowerOff,
  faFileSignature,
  faLightbulb,
  faLock,
  faTasks,
  faFileContract,
  faFileInvoiceDollar,
  faHourglassStart,
  faHourglassEnd,
  faTag,
  faClock,
  faChartLine,
  faChartArea,
  faChartPie,
  faEdit,
  faTicketAlt,
  faSwatchbook,
  faListAlt,
  faTachometerAlt,
  faUniversity,
  faFlag,
  faMoneyBill,
  faMoneyBillAlt,
  faFileInvoice,
  faFilter,
  faPen,
  faPlus,
  faMapMarker,
  faMapMarkerAlt,
  faMapMarkedAlt,
  faMapMarked,
  faTrash,
  faCog,
  faCogs,
  faDownload,
  faUserCog,
  faUsers,
  faUsersCog,
  faFileExcel,
  faStream,
  faBook,
  faExclamationTriangle,
  faShieldAlt,
  faProjectDiagram,
  faSolarPanel,
  faChargingStation,
  faInbox,
  faSave,
  faUserTie,
  faCoins,
  faCommentDots,
  faInfinity,
  faTimesCircle,
  faPaperPlane,
  faDatabase,
  faHandshake,
  faDesktop,
  faServer,
  faTabletAlt,
  faFileExport,
  faClipboardCheck,
  faBriefcase,
  faIdBadge,
  faStamp
} from '@fortawesome/free-solid-svg-icons';

// free regular icons
import { 
  faComment as faCommentR,
  faQuestionCircle as faQuestionCircleR,
  faStickyNote as faStickyNoteR
} from "@fortawesome/free-regular-svg-icons";

// load basic styles
require("@fortawesome/fontawesome-svg-core/styles.css");

// disable auto adding styles to head (CSP)
config.autoAddCss = false;

// add icons to library
library.add(
  faComment,
  faCommentR,
  faEnvelope,
  faEnvelopeOpen,
  faBars,
  faBell,
  faUser,
  faQuestionCircle, 
  faQuestionCircleR,
  faStickyNoteR,
  faCheckCircle, 
  faExclamationCircle, 
  faInfoCircle,
  faExclamationTriangle,
  faHome,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faAddressCard,
  faDonate,
  faComments,
  faFilePdf,
  faShoppingCart,
  faTimes,
  faSignOutAlt,
  faBuilding,
  faBan,
  faCheck,
  faBolt,
  faFire,
  faFileAlt,
  faSearch,
  faThermometerThreeQuarters,
  faCreditCard,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faLongArrowAltUp,
  faLongArrowAltDown,
  faArrowsAltH,
  faPhone,
  faFax,
  faGlobe,
  faMobileAlt,
  faCalendarAlt,
  faCalendar,
  faCalendarCheck,
  faCalendarTimes,
  faPlug,
  faPowerOff,
  faFileSignature,
  faLightbulb,
  faLock,
  faTasks,
  faFileContract,
  faFileInvoiceDollar,
  faHourglassStart,
  faHourglassEnd,
  faTag,
  faClock,
  faChartLine,
  faChartArea,
  faChartPie,
  faEdit,
  faTicketAlt,
  faSwatchbook,
  faListAlt,
  faTachometerAlt,
  faUniversity,
  faFlag,
  faMoneyBill,
  faMoneyBillAlt,
  faFileInvoice,
  faFilter,
  faPen,
  faPlus,
  faMapMarker,
  faMapMarkerAlt,
  faMapMarkedAlt,
  faMapMarked,
  faTrash,
  faCog,
  faCogs,
  faDownload,
  faUserCog,
  faUsers,
  faUsersCog,
  faFileExcel,
  faStream,
  faBook,
  faShieldAlt,
  faProjectDiagram,
  faSolarPanel,
  faChargingStation,
  faInbox,
  faSave,
  faUserTie,
  faCoins,
  faCommentDots,
  faInfinity,
  faTimesCircle,
  faPaperPlane,
  faDatabase,
  faHandshake,
  faDesktop,
  faServer,
  faTabletAlt,
  faFileExport,
  faClipboardCheck,
  faBriefcase,
  faIdBadge,
  faStamp
);